import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import records, { State as RecordsState } from "./records/reducers";
import selection, { State as SelectionState } from "./selection/reducers";
import thunk from "redux-thunk";

export interface RootState {
  records: RecordsState;
  selection: SelectionState;
}

const composeEnhancers =
  (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default createStore(
  combineReducers<RootState>({
    records,
    selection
  }),
  composeEnhancers(applyMiddleware(thunk))
);
